export var EQuestionCodes = /*#__PURE__*/function (EQuestionCodes) {
  EQuestionCodes["Topic"] = "topicQuestion";
  EQuestionCodes["CommonForm"] = "commonFormQuestion";
  EQuestionCodes["ModerationInitial"] = "moderationInitialQuestion";
  EQuestionCodes["ModerationIssues"] = "moderationIssuesQuestion";
  EQuestionCodes["ModerationFinal"] = "moderationFinalQuestion";
  EQuestionCodes["ComplaintFromOwnerProperty"] = "complaintFromOwnerPropertyQuestion";
  EQuestionCodes["ComplaintFromOwnerPhoto"] = "complaintFromOwnerPhotoQuestion";
  EQuestionCodes["OfferComplaintInitial"] = "offerComplaintInitialQuestion";
  EQuestionCodes["OfferComplaintFinal"] = "offerComplaintFinalQuestion";
  EQuestionCodes["Login"] = "LoginQuestion";
  EQuestionCodes["ChangedPhoneInitial"] = "changedPhoneInitialQuestion";
  EQuestionCodes["ChangedPhoneSearcherFinal"] = "changedPhoneSearcherFinalQuestion";
  EQuestionCodes["ChangedPhoneEmployeeFinal"] = "changedPhoneEmployeeFinalQuestion";
  EQuestionCodes["ChangedPhoneFinal"] = "changedPhoneFinalQuestion";
  EQuestionCodes["PartnerRewardsInitialQuestion"] = "partnerRewardsInitialQuestion";
  EQuestionCodes["XmlUnloading"] = "xmlUnloadingStepQuestion";
  return EQuestionCodes;
}({});